import {
  Component,
  EventEmitter,
  Injectable,
  Input,
  OnInit,
  Output,
  Pipe,
  PipeTransform,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommitteeApprovalType } from './committee-approval-type';
import {
  ClosingApprovalStatus,
  CommitteeApproval,
  CommitteeApprovalStatus,
} from './committee-approval';
import Project from '../../interfaces/project';
import {
  CommitteeApprovalsService,
  CommitteeApprovalResult,
} from './committee-approvals.service';
import { Subscription } from 'rxjs';
import Milestone from "../../interfaces/milestone";

@Component({
    selector: 'app-committee-approvals',
    templateUrl: './committee-approvals.component.html',
    styleUrls: ['./committee-approvals.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommitteeApprovalsComponent implements OnInit {
  @Input('approvalTypes') approvalTypes: CommitteeApprovalType[];
  @Input('milestoneApprovalTypes')
  milestoneApprovalTypes: CommitteeApprovalType[];
  @Input('milestoneId') milestoneId: string;
  @Input('projectId') projectId: string;
  @Input('milestoneName') milestoneName: string;
  @Input('project') project: Project;
  @Input('readOnly') readOnly:boolean;

  @Output('approvalsChange') approvalsChange = new EventEmitter<
    CommitteeApproval[]
  >();
  public approvals: CommitteeApproval[] = [];
  public isLoading: boolean = false;
  private _approvalsSub: Subscription;
  public usedApprovalTypes: CommitteeApprovalType[] = [];
  constructor(private approvalsService: CommitteeApprovalsService) {}
  ngOnInit() {
    if(this.milestoneName.toLowerCase() === 'closed'){
      this.usedApprovalTypes = this.milestoneApprovalTypes;
    }else{
      this.usedApprovalTypes = this.approvalTypes
    }
    this._approvalsSub = this.approvalsService
      .getApprovals(this.projectId, this.milestoneId)
      .subscribe((result: CommitteeApprovalResult) => {
        this.isLoading = result.isLoading;
        this.approvals = result.approvals;
        this.approvalsChange.emit(this.approvals);
      });
  }
  ngOnDestroy() {
    this._approvalsSub && this._approvalsSub.unsubscribe();
    this.approvalsService.cleanUp();
  }
  getApprovalIndex(approval: CommitteeApproval): number {
    return this.approvals.findIndex(
      (iApproval) => iApproval.id === approval.id
    );
  }
  getApprovalForType(
    approvalType: CommitteeApprovalType
  ): CommitteeApproval | null {
    return (
      this.approvals.find(
        (approval: CommitteeApproval) =>
          approval.committeeApprovalType?.id === approvalType.id &&
          approval.milestone_id === this.milestoneId
      ) ?? null
    );
  }
  updateApproval(approval: CommitteeApproval): void {
    if (approval.milestone_id && approval.project_id) {
      this.approvalsService.requestApprovals(approval.project_id);
    }
  }

  isApprovalOption(milestoneName: string, option: string){
    switch (option) {
      case 'yes':
        return true;
      case 'maybe':
        return true;
      case 'no':
        return true;
      case 'discuss':
        return milestoneName.toLowerCase() != 'closed';
      case 'unknown':
        return true;
      default:
        return true;

    }
  }
  tallyApprovals(status: string): number {
    return this.milestoneApprovalTypes.filter(
      (approvalType: CommitteeApprovalType) => {
        let approval = this.getApprovalForType(approvalType);
        if (approval?.status) {
          switch (status) {
            case 'yes':
              return approval.status === CommitteeApprovalStatus['Cleared'] || approval.status === ClosingApprovalStatus['Approve Fund & Release'];
            case 'no':
              return approval.status === CommitteeApprovalStatus['Not Cleared'] || approval.status === ClosingApprovalStatus['Not Approved'];
            case 'maybe':
              return (
                approval.status ===
                CommitteeApprovalStatus['Cleared with Disclosures'] || approval.status === ClosingApprovalStatus['Approve Fund Only']
              );
            case 'discuss':
              return (
                approval.status ===
                CommitteeApprovalStatus['Requires Discussion']
              );
          }
        } else if (status === 'unknown') {
          return true;
        }
        return false;
      }
    ).length;
  }
  isVotingMember(approvalType: CommitteeApprovalType): boolean {
    return (
      this.milestoneApprovalTypes.find(
        (type) => type.id === approvalType.id
      ) !== undefined
    );
  }
}
